export default __webpack_public_path__ + "static/31987-2964d426031e2b7c7cb1ff7ea85552b3.jpg";